<template>
  <div class="row mb-3 mt-2">
      <div class="col-md-6">
          <b>Сортировка</b>
          <select  class="form-control" v-model="sortType" @change="changeSort">
            <option :value="value" v-for="(name, value) in sortTypeVariants" :key="value"
                    :selected="sortType==value" v-html="name"></option>
          </select>
      </div>
      <div class="col-md-6">
          <b>На странице</b>
          <select  class="form-control" v-model="onPage" @change="changeOnPage">
            <option :value="v" v-for="v in onPageVariants" :key="v" :selected="onPage==v">{{ v }}</option>
          </select>
      </div>
  </div>
</template>


<script>

export default {
    name: 'ProductListSort',
    props: ['count'],
    data() {
        return {
            viewType: 'grid',
            sortType: 'popularity',
            sortTypeVariants: {
                'popularity': 'Популярности',
                 'sizes': 'Размерности',
                 'articul': 'Артикулу',
                 'code': 'Коду',
                'priceasc': 'Цене &uarr;',
                'pricedesc': 'Цене &darr;'
            },
            onPageVariants: [12, 24, 36],
            onPage: 12
        }
    },
    created: function () {
        this.parseUri()

    },
    methods: {
        parseUri() {
            if (document.location.search) {
                const filterParams = JSON.parse(decodeURI(document.location.search.split('&')[0]).substr(1));

                if (filterParams['vt']) {
                    this.viewType = filterParams['vt']
                }
                if (filterParams['op']) {
                    this.onPage = filterParams['op']
                }
                if (filterParams['st']) {
                    this.sortType = filterParams['st']
                }

            }
        },
        setOnPage(onPage){
            this.onPage = onPage
        },
        setSortType(sortType){
            this.sortType = sortType
        },
        setViewType(viewType){
            this.viewType = viewType
        },
        changeView(viewType) {
            this.viewType = viewType;
            this.$emit('change-view-type', this.viewType);
        },
        changeOnPage() {
            this.$emit('change-on-page', this.onPage);
        },
        changeSort() {
            this.$emit('change-sort', this.sortType);
        },
    }
}
</script>

<style>
.sort_opts .select2.select2-container {
    margin-top: -5px !important;
}
</style>
